import api from './BaseApi';

// GET all pending images with optional user filter
export const getPendingImages = async (params = {}) => {
  try {
    const response = await api.get('/admin/images/pending', { params });
    return response.data;
  } catch (error) {
    console.error('Get pending images error:', error);
    throw error;
  }
};

// GET approved images
export const getApprovedImages = async (params = {}) => {
  try {
    const response = await api.get('/admin/images/approved', { params });
    return response.data;
  } catch (error) {
    console.error('Get approved images error:', error);
    throw error;
  }
};

// GET images for specific user
export const getImagesByUser = async (userId, status = 'pending') => {
  try {
    const response = await api.get(`/admin/users/${userId}/images`, {
      params: { status }
    });
    return response.data;
  } catch (error) {
    console.error('Get user images error:', error);
    throw error;
  }
};

// APPROVE single image
export const approveImage = async (imageId) => {
  try {
    const response = await api.post(`/admin/images/${imageId}/approve`);
    return response;
  } catch (error) {
    console.error('Approve image error:', error);
    throw error;
  }
};

// REJECT single image
export const rejectImage = async (imageId, reason = '') => {
  try {
    const response = await api.post(`/admin/images/${imageId}/reject`, { reason });
    return response;
  } catch (error) {
    console.error('Reject image error:', error);
    throw error;
  }
};

// BULK APPROVE images
export const bulkApproveImages = async (imageIds) => {
  try {
    const response = await api.post('/admin/images/bulk-approve', { ids: imageIds });
    return response;
  } catch (error) {
    console.error('Bulk approve error:', error);
    throw error;
  }
};

// BULK REJECT images
export const bulkRejectImages = async (imageIds, reason = '') => {
  try {
    const response = await api.post('/admin/images/bulk-reject', {
      ids: imageIds,
      reason
    });
    return response;
  } catch (error) {
    console.error('Bulk reject error:', error);
    throw error;
  }
};

// GET all users with pending images
export const getUsersWithPendingImages = async () => {
  try {
    const response = await api.get('/admin/users/with-pending-images');
    return response.data;
  } catch (error) {
    console.error('Get users with pending images error:', error);
    throw error;
  }
};

